import { CashFlowLedgerItem } from '../data/types';

// Drops the manual rows at the given 1-based sheet rows in one pass; virtual (fund-derived) rows are never removed.
export const removeRowsByIndex = (rows: CashFlowLedgerItem[], rowIndexes: number[]) => {
  const doomed = new Set(rowIndexes.map(rowIndex => rowIndex - 1));
  return rows.filter((row, index) => row.is_virtual || !doomed.has(index));
};
